function OutputDate({ field, object }) {
  const value = object[field];
  if (!value) return null;

  const date = new Date(value);
  if (isNaN(date)) return null;

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  if (field === "created") {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const minutesStr = minutes.toString().padStart(2, "0");
    const secondsStr = seconds.toString().padStart(2, "0");

    return `${month} ${day}, ${year} - ${hours}:${minutesStr}:${secondsStr} ${ampm}`;
  } else {
    return `${month} ${day}, ${year}`;
  }
}

export default OutputDate;
